import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom'
import axios from "axios"

const SignUp = () => {
  const  navigate=useNavigate()
    const [signupDetails, setSignUpDetails] = useState({
        fname: "",
        lname: "",
        email: "",
        phone: "",
        pass: "",
        cpass: "",
    })

    const gotoLogin=()=>{
        navigate('/signin')
    }

    
    const signupHandle = async(e) => {
        e.preventDefault()
        await axios.post("http://localhost:9090/signup",signupDetails).then(res=>{
            console.log("+++++ res +++++",res)
            if(res.data.status===200){
                navigate("/signin")
            }
        }).catch(err=>{
            console.log("++++ err +++++",err)
        })


       

        // setSignToggle(false)
    }
  return (
    <div>
        <div className="signcontainer">
          <div className="signupform-container">
                        <form className='signUpform' action="#">
                            <h1 className='titleHeading'>Create Account</h1>
                            <div className="social-container">
                                <a href="https://www.google.com" className="social"><i className="fab fa-facebook-f"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-google-plus-g"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                            <input
                                value={signupDetails.fname}
                                onChange={(e) => setSignUpDetails({
                                    ...signupDetails, fname: e.target.value
                                })}
                                type="text" required={true} placeholder="First name" />
                            <input
                            required={true}
                                value={signupDetails.lname}
                                onChange={(e) => setSignUpDetails({
                                    ...signupDetails, lname: e.target.value
                                })}

                                type="text" placeholder="Last name" />

                            <input type="email"

                                value={signupDetails.email}
                                onChange={(e) => setSignUpDetails({
                                    ...signupDetails, email: e.target.value
                                })}

                                required={true} placeholder="Email" />
                            <input type="text" 
                             value={signupDetails.phone}
                             onChange={(e)=>setSignUpDetails({
                                         ...signupDetails,phone:e.target.value
                                    })}
                            required={true} placeholder='Phone Number' />
                            <input 
                             value={signupDetails.pass}
                             onChange={(e)=>setSignUpDetails({
                                         ...signupDetails,pass:e.target.value
                                    })}type="password" required={true} placeholder="Password" />
                            <input
                             value={signupDetails.cpass}
                             onChange={(e)=>setSignUpDetails({
                                         ...signupDetails,cpass:e.target.value
                                    })}
                             type="password" required={true} placeholder="Confirm password" />

                            <button onClick={signupHandle}>Sign Up</button>
                        </form>                          
                           <button onClick={gotoLogin} style={{border:"none", marginTop:"12px", color: "blue", background: "none"}}>Already have an account?</button>

                    </div>
    </div>
    </div>
  )
}

export default SignUp